import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import { Box, Fab, IconButton, Typography } from '@mui/material';
import React from 'react';
import { Close } from '@mui/icons-material';

export interface ItemSumario {
  hash: string;
  title: string;
  contentText?: string;
  subitems?: ItemSumario[];
  type: "item" | "divider" | "title";
}

export const convertItemSumarioToObjSumario = (item: ItemSumario): ObjSumario => ({
  title: item.title,
  type: item.type === "divider" ? "title" : (item.type as "item" | "title"),
  screen: item.contentText ? <div>{item.contentText}</div> : undefined,
  subitens: item.subitems?.map(convertItemSumarioToObjSumario),
});

export interface ObjSumario {
  title?: string;
  type: "item" | "title";
  screen?: JSX.Element;
  subitens?: ObjSumario[];
}

interface SumarioProps {
  items: ObjSumario[] | null;
  onSelect: (item: ObjSumario) => void;
  onClose?: () => void;
}

export const Sumario: React.FC<SumarioProps> = ({ items, onSelect, onClose }) => {

  const renderTree = (nodes: ObjSumario[], path = ''): JSX.Element[] => {
    return nodes.map((node, index) => {
      const currentPath = path ? `${path}-${index}` : `${index}`;

      return (
        <TreeItem
          key={currentPath}
          itemId={currentPath}
          label={
            <Typography fontWeight={node.type === 'title' ? 'bold' : 'normal'}>
              {node.title}
            </Typography>
          }
          onClick={(event) => {
            event.stopPropagation();
            onSelect(node);
          }}
        >
          {node.subitens ? renderTree(node.subitens, currentPath) : null}
        </TreeItem>
      );
    });
  };

  return (
    <Box sx={{ position: 'relative', width: "100%", height: "100%", overflow: "auto" }}>
      <SimpleTreeView
        sx={{ flexGrow: 1, overflowY: 'auto' }}
        defaultExpandedItems={[]}
      >
        {items ? renderTree(items) : null}
      </SimpleTreeView>

      {/* Botão flutuante */}
      {onClose && <IconButton
        size="small"
        sx={{
          position: 'absolute',
          top: 0,
          right: "0.5em",
          zIndex: 1000,
        }}
        onClick={onClose}
      >
        <Close fontSize="small" />
      </IconButton>}
    </Box>
  );
};
